module.exports = __webpack_public_path__ + "img/小蜴.2a7e59d7.png";